import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { startAutoLogin } from "../redux/slices/auth";

import { PrivateRouter } from "./";
import { PublicRouter } from "./";

import { NotificationsSystem } from "../components";

export const AppRouter = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(startAutoLogin())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { status } = useSelector(state => state.auth);

    return (
        <>
            <NotificationsSystem />
            {status === 'auto-checking' ? <div>Autenticación de usuario...</div> : (status === 'authenticated' ? <PrivateRouter /> : <PublicRouter />) }
        </>
    )
}
